import { zodResolver } from "@hookform/resolvers/zod";
import { useSetAtom } from "jotai";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	type FilterFormValues,
	getFilterFormSchema,
} from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { normalizePortfolioFilter } from "web_myplann/Portfolio/Helpers/normalizePortfolioFilter";
import { useEffectivePortfolioFilter } from "web_myplann/Portfolio/Hooks/useEffectivePortfolioFilter";
import {
	defaultPortfolioFilterState,
	portfolioFilterState,
} from "web_myplann/Shared/State/portfolioFilterAtom";

export const useFilterForm = () => {
	const navigate = useNavigate();
	const setFilter = useSetAtom(portfolioFilterState);
	const { filter, availableByContractState } = useEffectivePortfolioFilter();

	const form = useForm<FilterFormValues>({
		resolver: zodResolver(getFilterFormSchema()),
		defaultValues: filter,
		mode: "onChange",
	});

	const onSubmit = form.handleSubmit((values) => {
		navigate(Routing.Portfolio.PortfolioList.path());
		setFilter(normalizePortfolioFilter(values, availableByContractState));
	});

	const reset = () => form.reset(defaultPortfolioFilterState);

	return { form, onSubmit, reset };
};
